export const PRODUCT_ANALYTICS_APPS = {
  TEACH_LEAGUE: "teachleague",
  MISSING_VOICES: "missingvoices",
  MEMNON: "memnon",
};

export const PRODUCT_ANALYTICS_EVENTS = {
  PAGE_VIEWED: "page_viewed",
  SIGNUP_COMPLETED: "signup_completed",
  LOGIN_COMPLETED: "login_completed",
  ANALYSIS_COMPLETED: "analysis_completed",
  RECOMMENDATIONS_APPLIED: "recommendations_applied",
  PLAN_GENERATED: "plan_generated",
};

const DEFAULT_TEXT_BUCKETS = [0, 200, 500, 1000, 2000, 4000, 8000];

export const getSizeBucket = (value = 0, thresholds = DEFAULT_TEXT_BUCKETS) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return "0";
  }

  for (let index = 0; index < thresholds.length - 1; index += 1) {
    const lower = thresholds[index];
    const upper = thresholds[index + 1];
    if (numericValue <= upper) {
      return `${lower + 1}_${upper}`;
    }
  }

  return `${thresholds[thresholds.length - 1] + 1}_plus`;
};

export const getBooleanFlag = (value) => Boolean(value);
